var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dropdown",staticClass:"base-dropdown",class:{
    'active': _vm.isActive || _vm.isHovered,
    'base-dropdown_wide': !_vm.autoWidth,
  }},[(!_vm.hideOverlay)?_c('div',{staticClass:"base-dropdown__overlay"}):_vm._e(),_vm._v(" "),_c('div',{ref:"block",staticClass:"base-dropdown__block"},[_c('div',{staticClass:"base-dropdown__container"},[_c('div',{staticClass:"base-dropdown__menu"},[_vm._t("items")],2)])])])}
var staticRenderFns = []

export { render, staticRenderFns }